import axios from "@/lib/axios";

export type UpdateQuizAnswerRequestParams = {
  companyId: string;
  quizId: string;
  questionId: string;
  choiceId?: string;
  value?: string;
  action: "ADD" | "REMOVE";
};

export type UpdateQuizAnswerResponse = void;

export const updateQuizAnswer = (params: UpdateQuizAnswerRequestParams) =>
  axios
    .put<UpdateQuizAnswerResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/${params.quizId}/responses`,
      {
        questionId: params.questionId,
        choiceId: params.choiceId,
        value: params.value,
        action: params.action,
      },
    )
    .then((res) => res.data);
